import React from "react"
import "./frames.css"

const SeleccionUbicacion = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">Selección de Ubicación</h1>
      <p className="frames-text">
        Encontrar un punto estratégico donde ubicar nuestra nueva Unidad de
        Medicina Hiperbárica puede ser una de las claves más importantes de su
        éxito. Te ayudamos a reconocer la potencialidad de tus propuestas en
        función del panorama actual y previsiones futuras.
      </p>
    </div>
  )
}

export default SeleccionUbicacion
